var $4ed19d2fc07f94be$exports = {};
$4ed19d2fc07f94be$exports = {
    "collectionLabel": `Predlozi`
};


export {$4ed19d2fc07f94be$exports as default};
//# sourceMappingURL=sr-SP.module.js.map
